// extracted by mini-css-extract-plugin
export default {"wrapper":"UiNumberPicker_wrapper","button":"UiNumberPicker_button","number":"UiNumberPicker_number"};